import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MarqueeBand from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import BlogGrid from "@/components/BlogGrid";
import Comparison from "@/components/Comparison";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";

const Home = () => (
  <main data-testid="home-page">
    <Nav />
    <Hero />
    <MarqueeBand />
    <Manifesto />
    <BlogGrid />
    <Comparison />
    <Faq />
    <Footer />
  </main>
);

export default Home;
